const ERROR_MESSAGE = 'An unexpected error occurred sending your request. Please try again.';
const SUCCESS_MESSAGE = 'Your demo request was sent successfully!';
const VERIFICATION_MESSAGE = 'Please complete the verification and try again.';
const TURNSTILE_RESPONSE_FIELD = 'cf-turnstile-response';
const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
const TURNSTILE_SITE_KEY = '0x4AAAAAAD8DIsjsf_BNvB8m';

const getResponseMessage = (response, fallback) => (
    response.message || response.error?.message || fallback
);

const showAlert = (form, type, message) => {
    form.querySelector('.alert')?.remove();

    const alert = document.createElement('div');
    alert.className = `alert alert-${type}`;
    alert.setAttribute('role', 'alert');
    alert.textContent = message;
    form.prepend(alert);

    return alert;
};

const getRequestBody = (form) => {
    const requestBody = Object.fromEntries(new FormData(form));

    if (!requestBody.name) {
        const fullName = [requestBody.firstName, requestBody.lastName]
            .filter(Boolean)
            .join(' ');

        if (fullName) {
            requestBody.name = fullName;
        }
    }

    delete requestBody.firstName;
    delete requestBody.lastName;

    return requestBody;
};

const resetTurnstile = (form) => {
    const widget = form.querySelector('.cf-turnstile');

    if (widget && window.turnstile) {
        window.turnstile.reset(widget);
    }
};

const submitDemoRequest = async (form) => {
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton?.setAttribute('disabled', 'disabled');

    try {
        const requestBody = getRequestBody(form);

        if (!requestBody[TURNSTILE_RESPONSE_FIELD]) {
            throw new Error(VERIFICATION_MESSAGE);
        }

        const response = await fetch(form.action, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || result.status === false) {
            throw new Error(getResponseMessage(result, ERROR_MESSAGE));
        }

        const alert = showAlert(form, 'success', getResponseMessage(result, SUCCESS_MESSAGE));
        form.reset();

        window.setTimeout(() => alert.remove(), 6000);
    } catch (error) {
        showAlert(form, 'danger', error.message || ERROR_MESSAGE);
        resetTurnstile(form);
        submitButton?.removeAttribute('disabled');
    }
};

const demoForms = document.querySelectorAll('form.demo');

if (demoForms.length) {
    document.querySelectorAll('.cf-turnstile').forEach((widget) => {
        widget.dataset.sitekey = TURNSTILE_SITE_KEY;
    });

    const loadTurnstile = () => {
        const turnstileScript = document.createElement('script');
        turnstileScript.src = TURNSTILE_SCRIPT_URL;
        turnstileScript.async = true;
        turnstileScript.defer = true;
        document.head.appendChild(turnstileScript);
    };

    if (document.readyState === 'complete') {
        loadTurnstile();
    } else {
        window.addEventListener('load', loadTurnstile, { once: true });
    }
}

demoForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitDemoRequest(form);
    });
});
